import styled from 'styled-components'

export const ArticleContainer = styled.div`
padding-top: 88px;
overflow: auto;

.article-title{
  color: #222B45;
  font-weight: 700;
  font-size: 36px;
  margin-top: 32px;
  margin-left: 16px;
  margin-right: 16px;
}

.article-body{
  color: #222B45;
  margin-top: 8px;
  margin-left: 16px;
  margin-right: 16px;
}

.article-button-row{
  margin-right: 16px;
  margin-bottom: 50px;
  margin-top: 32px;
}

  @media(min-width: 768px){
    width: 65%;
    left: 35%;
    position: relative;
    .article-title, .article-body{
      margin-left: 24px;
      margin-right: 24px;
    }
    .article-button-row{
      margin-right: 24px;
    }
  }

  @media(min-width: 1025px){
    width: 65%;
    left: 35%;
    .article-title, .article-body{
      margin-right: 128px;
    }
    .article-button-row{
      margin-right: 128px;
    }
  }

`

